import React, { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { isProfileCompleted } from "../../utils";
import Main from "./Components/Main/Main";
import Setting from "./Components/Setting/Setting";
import GuestProfile from "../Profile/GuestProfile";
import Messages from "./Components/Messages/Messages";

const DashboardPage = React.memo(() => {
  const location = useLocation();

  // Initialize tab state based on URL parameter immediately
  const getInitialTab = () => {
    const params = new URLSearchParams(location.search);
    const tabName = params.get("tab");
    return tabName && tabName !== "" ? tabName : "dashboard";
  };

  const [tab, setTab] = useState(getInitialTab);
  const { isGuest } = useSelector((state) => state.main);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabName = params.get("tab");

    if (tabName && tabName !== "") {
      setTab(tabName);
    } else {
      if (isGuest) {
        setTab("setting");
      } else {
        setTab("dashboard");
      }
    }
  }, [isGuest, location]);

  const handleScrollToTop = useCallback(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    handleScrollToTop();
  }, [tab, handleScrollToTop]);

  return (
    <>
      {isGuest || (tab === "dashboard" && <Main />)}
      {tab === "setting" && <Setting />}
      {isGuest && tab === "profile" && <GuestProfile />}
      {tab === "message" && <Messages />}
    </>
  );
});

DashboardPage.displayName = 'DashboardPage';

export default DashboardPage;
